import React, { Component } from "react";
import { Control, Errors, actions } from "react-redux-form";
import {
  FormGroup,
  ControlLabel,
  FormControl,
  OverlayTrigger,
  Tooltip,
  Button,
} from "react-bootstrap";
import { validators } from "../../../../utils/validators";
import PropTypes from "prop-types";

class RequiredInput extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  updateErrors = (field, value) => {
    this.setState({
      [field]: value,
    });
  };

  changeAction = (model, value) => {
    return (dispatch) => {
      dispatch(actions.change(model, value));
      dispatch(actions.resetValidity(model));
      if (typeof this.props.onChange === "function") {
        this.props.onChange(value);
      }
    };
  };

  render() {
    const {
      model,
      label,
      inputType,
      controlId,
      errorLabel,
      tooltip,
      debounce,
      validations,
      messages,
      ...props
    } = this.props;
    
    return (
      <FormGroup controlId={controlId} validationState={this.state[errorLabel]}>
        {label && <ControlLabel>{label}*</ControlLabel>}
        {tooltip && (
          <OverlayTrigger
            placement="left"
            overlay={
              <Tooltip id="tooltip" className="tooltip dark-grey">
                {tooltip}
              </Tooltip>
            }
          >
            <Button className="tip pull-right" tabIndex="-1">
              ?
            </Button>
          </OverlayTrigger>
        )}

        <Control
          type={inputType}
          model={model}
          validators={{
            ...validations,
            required: validators.required(this.updateErrors, errorLabel),
          }}
          changeAction={this.changeAction}
          component={FormControl}
          debounce={debounce || 0}
          {...props}
          onChange={false}
        />

        <Errors
          show={{ touched: true, focus: false }}
          className="errors"
          model={model}
          messages={{
            ...messages,
            required: 'This is a required field',
            patternMismatch: 'Value does not match the required pattern'
          }}
        />
      </FormGroup>
    );
  }
}

RequiredInput.propTypes = {
  model: PropTypes.string.isRequired,
  label: PropTypes.string,
  inputType: PropTypes.string,
  pattern: PropTypes.string,
  controlId: PropTypes.string,
  placeholder: PropTypes.string,
  errorLabel: PropTypes.string,
  tooltip: PropTypes.string,
  debounce: PropTypes.number,
};

RequiredInput.defaultProps = {
  inputType: "text",
  controlId: Math.random().toString(16).substring(2),
  errorLabel: "error",
};

export default RequiredInput;



// WEBPACK FOOTER //
// ./src/components/common/form/elements/required-input.jsx